module.exports = __webpack_public_path__ + "img/37.9f51dbe.webp";